import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import './CompanyFormNav.css';

// Allow quick navigation to headers in the form
class CompanyFormNav extends React.Component {
  static propTypes = {
    companyInfo: PropTypes.object,
    companyProfile: PropTypes.array,
    companyOffice: PropTypes.array,
    companyPerson: PropTypes.object,
    location: PropTypes.object
  };

  _renderPersonName = (employee) => {
    if (employee.firstName) {
      // If "First Name" field was filled out, set the section label to that
      return employee.firstName;
    } else if (employee.fullName) {
      // If "Full Name" field was filled out, derive first name from that        
      return employee.fullName.substr(0, employee.fullName.indexOf(' '));
    } else {
      // If no fields were filled out, the section label is the person code
      return employee.code;
    }
  }

  render() {
    const {
      companyInfo,
      companyProfile,
      companyOffice,
      companyPerson,
      location
    } = this.props;

    return (
      <div className='CompanyFormNav-root'>
        <h2 className='CompanyFormNav-header'>Quick Nav</h2>
        <Link className='CompanyFormNav-link' to={location.search + '#publish'}>PUBLISH STATUS</Link>
        <Link className='CompanyFormNav-link' to={location.search + '#essential'}>Essential Info</Link>
        <Link className='CompanyFormNav-link' to={location.search + '#info'}>Company Info</Link>
        <Link className='CompanyFormNav-link' to={location.search + '#employees'}>Company Employees</Link>
        <Link className='CompanyFormNav-link' to={location.search + '#profile'}>Company Profile</Link>
        <div className='CompanyFormNav-section'>
          {
            companyProfile.map((block, index) => (
              <Link
                key={'profile-' + (index + 1)} 
                className='CompanyFormNav-link-indented' 
                to={location.search + '#profile' + (index + 1)}
              >
                Block {index + 1}
              </Link>            
            ))
          }
        </div>
        <div className='CompanyFormNav-section'>
          <Link className='CompanyFormNav-link' to={location.search + '#office'}>Company Office</Link>
          { 
            companyInfo.officeEnabled && companyOffice.map((block, index) => (
              <Link
                key={'profile-' + (index + 1)} 
                className='CompanyFormNav-link-indented' 
                to={location.search + '#office' + (index + 1)}
              >
                Block {index + 1}
              </Link>            
            ))
          }
        </div>
        <div className='CompanyFormNav-section'>
          {
            companyInfo.employeesEnabled && companyInfo.employees.map((person) => (
              person.code && person.codeLocked &&
              <div key={`link-${person.code}`} className='CompanyFormNav-section'>
                <Link className='CompanyFormNav-link' to={location.search + '#' + person.code}>
                  {this._renderPersonName(person)}
                </Link>
                <div className='CompanyFormNav-section'>
                  {
                    companyPerson[person.code].map((block, index) => (
                      <Link
                        key={'profile-' + (index + 1)} 
                        className='CompanyFormNav-link-indented' 
                        to={location.search + '#' + person.code + (index + 1)}
                      >
                        Block {index + 1}
                      </Link>            
                    ))
                  }
                </div>
              </div>
            ))
          }
        </div>
      </div>
    );
  }
}

const connectedCompanyFormNav = connect(
  (state) => ({
    location: state.router.location
  })
)(CompanyFormNav);

export default connectedCompanyFormNav;



// WEBPACK FOOTER //
// ./src/components/companyform/CompanyFormNav/CompanyFormNav.js